import { useState } from 'react';
import { css } from '@emotion/react';
import type { FallbackRender } from '@sentry/react';
import { navigateToUrl } from '@frontend/auth';
import { theme } from '@frontend/theme';
import { Heading, Button } from '@frontend/design-system';

type Props = Parameters<FallbackRender>[0];

export const ErrorBoundary = ({ error }: Props) => {
  const [showingDetails, setShowingDetails] = useState(false);

  return (
    <main
      css={css`
        margin: ${theme.spacing(4)} auto auto;
        max-width: 400px;
        border-radius: ${theme.borderRadius.small};
        padding: ${theme.spacing(2)};
      `}
    >
      <Heading
        level={2}
        css={css`
          margin-bottom: ${theme.spacing(2)};
        `}
      >
        An Error Occurred
      </Heading>
      <Button variant='primary' onClick={() => navigateToUrl('/')} id='error-start-over-button'>
        Start Over
      </Button>
      <Button
        iconName='info'
        size='small'
        label='Show Details'
        onClick={() => setShowingDetails(!showingDetails)}
        css={css`
          margin-left: auto;
          margin-top: ${theme.spacing(2)};
          margin-bottom: ${theme.spacing(2)};
        `}
        id='error-show-details-button'
      />
      {showingDetails && (
        <p
          css={css`
            overflow: auto;
            padding: ${theme.spacing(2)};
            background: ${theme.colors.neutral10};
            border-radius: ${theme.borderRadius.small};
          `}
        >
          {error instanceof Error ? error?.stack : <code>Hmm, no error found</code>}
        </p>
      )}
    </main>
  );
};
